/**
 * Resolve a destination the user TYPED against the remote directory they are
 * in: absolute if it starts with `/`, otherwise relative, with `.` and `..`
 * collapsed.
 *
 * Its own module so it can be executed in a test: it decides where a
 * "Move to…" sends someone's files, and a path helper that is only ever
 * source-pinned is a path helper nobody has actually run.
 *
 * `..` above the root stays AT the root rather than producing a path the server
 * would read as something else. Repeated and trailing slashes collapse, so
 * `/var//www/` and `/var/www` are the same destination.
 */
export function resolveRemotePath(current, typed) {
  const raw = String(typed ?? '').trim();
  const base = raw.startsWith('/') ? raw : `${String(current || '/')}/${raw}`;
  const out = [];
  for (const part of base.split('/')) {
    if (!part || part === '.') continue;
    if (part === '..') out.pop();
    else out.push(part);
  }
  return `/${out.join('/')}`;
}

export default resolveRemotePath;
